export const iconFontAwesomeCodingGear = (
	<i className="fa-solid fa-gear"></i>
);
